export default "__VITE_ASSET__CeArZdJz__"